import { Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { BrandLogo } from '@cibo/profile'
import { useProgramConfig } from '@cibo/programs'

type ApprovedPartnersProps = {
  programId: string
}

export const ApprovedPartners = ({ programId }: ApprovedPartnersProps) => {
  const { t } = useTranslation('genericProgramDetails')
  const config = useProgramConfig({ programId })

  const partners = config.data?.program?.partnerOrgs

  if (!partners) return null

  return (
    <Stack spacing={1}>
      <Typography>{t('approvedPartners')}</Typography>
      <Stack direction="row" spacing={1}>
        {partners?.map(({ contentfulOrgId }) => (
          <BrandLogo key={contentfulOrgId} contentfulOrgId={contentfulOrgId} />
        ))}
      </Stack>
    </Stack>
  )
}
